/** HTTP error keeping the status, so polling can stop on a 401. */
export class DiagnosticRuleHttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'DiagnosticRuleHttpError';
  }
}
